import { get, post } from 'axios'

const host = process.env.VUE_APP_CCAPI
const hostAPICABSACORE = process.env.VUE_APP_APICABSACORE
const apiCabsaCore = "eyJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl9hdXRoIjoiNTNmNjc5NGYtNmVjMS00NmExLWE4MmYtYWFjNWMwMmYzMWRkIn0.X8yE0ZiUF86xOYwYpeqUu7wBlyhnjs6-Hz91_VgR9Bg";

function login (email, password) {
    const resource = `/fas/login`
    const API_URL = `${host}${resource}`

    const config = {
        headers: {
        "Content-Type": "application/json",
        }
    };

    const params = {
        user: {
            email: email.toLowerCase(),
            password: password
        }
    }

    return post(API_URL,  params, config )
}

function authenticate (rfc, nip) {
    const resource = `/authentication/fas/user`
    const API_URL = `${host}${resource}`


    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        rfc: rfc,
        nip: nip
    }

    return get(API_URL, { params, config } )
}

function authenticateByRfc (token_auth, rfc) {
    const resource = `/fas/member/get_by_rfc`
    const API_URL = `${host}${resource}`


    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        token_auth: token_auth,
        rfc: rfc
    }

    return get(API_URL, { params, config } )
}

function validateRFC (rfc) {
    const resource = `/rfc_es_valido`
    const API_URL = `${hostAPICABSACORE}${resource}`

    const config = {
        headers: {
            "Content-Type": "application/json",
        }
    };

    const params = {
        rfc: rfc,
        token_auth: apiCabsaCore,
    }

    return get(API_URL, { params, config } )
}

export {
    login,
    authenticate,
    authenticateByRfc,
    validateRFC
}